import { createSlice } from "@reduxjs/toolkit";

export const initialState: any = {
  UserData:[],
  SingleUserData:[],
  userSuccessMsg: {
    message: "",
    id: ""
  },
  deleteSuccessMsg: {
    message: "",
    id: ""
  },
  userErrorMsg: "",
  loading: true,
  apierror: {},
  paginationCount: {},
  pagination: {},
  deleteUserSuccessfull: false,
  editUserSuccessfull: false,
  userSingleSuccessMSg: "",
  userSingleErrorMsg: ""
};

const userSlice = createSlice({
  name: "user",
  initialState,
    reducers: {
    fetchSingleUserData(state,action){
state.SingleUserData = action.payload.data;
    },
    fetchUserDataSuccess(state, action) {
      state.UserData = action.payload.data;
    },
    setPaginationCount(state, action){
      state.paginationCount = action.payload;
    },
    setPagination(state, action){
      state.pagination = action.payload;
    },

   isDelete(state){
 state.deleteUserSuccessfull =   !state.deleteUserSuccessfull;

   },
   isEdit(state){
      state.editUserSuccessfull =   !state.editUserSuccessfull;
   },
    editAndDeleteUserSuccessMsg(state, action) {
      // console.log("print msg",action.payload);
      state.userSuccessMsg.message = action.payload.message; 
      state.userSuccessMsg.id = action.payload.id; 
      // state.userSuccessMsg = action.payload;
      //using as a dependecy during api call in user
     

    },
    deleteUserSuccessMsg(state, action) {
      state.deleteSuccessMsg.message = action.payload.message; 
      state.deleteSuccessMsg.id = action.payload.id; 
      console.log("delete success msg", state.deleteSuccessMsg) ;   

    },
    editAndDeleteUserErrorMsg(state, action) {
      state.userErrorMsg = action.payload;
      state.deleteUserSuccessfull = false;
      state.editUserSuccessfull = !state.editUserSuccessfull;

    },

    setUserLoader (state, action) {
      state.loading = action.payload;
    },
    
    clearUserMessages(state) {
      state.userSuccessMsg = { message: "", id: "" };
      state.deleteSuccessMsg = { message: "", id: "" };
      state.userErrorMsg = "";
    }
  },
  
});

export const {
  fetchUserDataSuccess,
  fetchSingleUserData,
  setPagination,
  setPaginationCount,
  setUserLoader,
  editAndDeleteUserSuccessMsg,
  editAndDeleteUserErrorMsg,
  isDelete,
  isEdit,
  deleteUserSuccessMsg,
  clearUserMessages
} = userSlice.actions;



export default userSlice.reducer;
